import {
  Component,
  ChangeDetectionStrategy,
  Input,
  TemplateRef,
  Output,
  EventEmitter,
  ViewEncapsulation,
} from '@angular/core';

import { SliderBaseInterface } from '../interfaces/slider.interface';

@Component({
  selector: 'mb-item-slider',
  templateUrl: './item-slider.component.html',
  styleUrls: ['./item-slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ItemSliderComponent {
  @Input() config: SliderBaseInterface = {
    inGrid: true,
    itemsToSlide: 1,
    itemsToShow: 1,
  };
  @Input() itemTpl!: TemplateRef<any>;
  @Input() items!: any[];
  @Input() initialIndex: number = 0;
  @Output() indexChanged = new EventEmitter();
}
